import { render, staticRenderFns } from "./communityInformationEdit.vue?vue&type=template&id=469675c2&scoped=true"
import script from "./communityInformationEdit.vue?vue&type=script&lang=js"
export * from "./communityInformationEdit.vue?vue&type=script&lang=js"
import style0 from "./communityInformationEdit.vue?vue&type=style&index=0&id=469675c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469675c2",
  null
  
)

export default component.exports